import * as React from "react";
import * as main from "../../main.module.scss";
import * as chapters from "./style.module.scss";
export const Chapters = () => {
  return (
    <section className={chapters.chapters}>
      <div className="container">
        <h2 className={main.title}>4 раздела курса включают в&nbsp;себя:</h2>
        <ul>
          <li>
            <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/razd1.png" alt=""/>
            <p>Интерактивные упражнения на платформе</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/razd2.png" alt=""/>
            <p>Тренировка<br/>чтения</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/razd3.png" alt=""/>
            <p>Тренировка внимания и памяти</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/razd4.png" alt=""/>
            <p>Раздаточный материал для ребёнка</p>
          </li>
        </ul>
      </div>
    </section>
  );
};
